import React, { useEffect } from "react";
import MessageBanner from "../../Components/Molecules/PaymentsAppHeader/MessageBanner";
import { useParams } from "react-router-dom";
import { useInvoiceStore } from "../../Store/Invoice";
import { capitalizeAfterSpace } from "../../Contracts/Common";
import { PaymentsInvoiceAutoCollectionStatus } from "../../Contracts/Invoice";
import CheckMarkLottie from "../../Assets/ClientPortalLoginPage/CheckMarkLottie.json";
import Lottie from "react-lottie";

const colorMapForAutoCollectStatus = {
  [PaymentsInvoiceAutoCollectionStatus.Pending]: "text-yellow-600",
  [PaymentsInvoiceAutoCollectionStatus.Collected]: "text-green-600",
  [PaymentsInvoiceAutoCollectionStatus.Initiated]: "text-green-600",
  [PaymentsInvoiceAutoCollectionStatus.Failed]: "text-red-600",
  [PaymentsInvoiceAutoCollectionStatus.Canceled]: "text-blue-600",
  [PaymentsInvoiceAutoCollectionStatus.AlreadyPaid]: "text-green-600"
};

const InvoiceAutoCollectDetailsPage: React.FC = () => {
  const { invoice_id, auto_collect_id } = useParams();
  const [actionCompleteSuccess, setActionCompleteSuccess] = React.useState(false);
  const { getAutoCollectDetails, autoCollectDetails, cancelAutoCollect, isLoading } =
    useInvoiceStore();

  useEffect(() => {
    if (invoice_id && auto_collect_id) {
      getAutoCollectDetails(invoice_id, auto_collect_id);
    } else {
      console.error("Invoice AutoCollect not found");
    }
  }, [invoice_id, auto_collect_id, getAutoCollectDetails]);

  const handleOnCancelClick = async () => {
    if (!autoCollectDetails || !invoice_id) {
      console.error("Invoice AutoCollect not found");
      return;
    }
    await cancelAutoCollect(parseInt(invoice_id), autoCollectDetails.customer_id);
    setActionCompleteSuccess(true);
  };

  return (
    <div className="min-h-screen flex justify-center bg-gray-50 px-4 pt-20">
      <MessageBanner />
      <div className="w-full max-w-md bg-white shadow-md rounded-xl p-6 h-fit">
        {actionCompleteSuccess ? (
          <>
            <Lottie
              options={{ animationData: CheckMarkLottie }}
              width="14rem"
              isClickToPauseDisabled
              style={{ cursor: "default" }}
            />
            <div className="font-semibold text-xl text-green-600 text-center">
              Thank you, <br />
              We have canceled the automated collection for this invoice.
            </div>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Cancel your auto-collect
            </h1>

            <div className="mb-4">
              <p className="text-sm text-gray-500">Invoice Number</p>
              {isLoading ? (
                <div className="h-5 bg-gray-200 rounded w-32 animate-pulse"></div>
              ) : (
                <p className="text-lg font-medium text-gray-800 ">
                  {autoCollectDetails?.invoice_number}
                </p>
              )}
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-500">Outstanding Amount</p>
              {isLoading ? (
                <div className="h-5 bg-gray-200 rounded w-24 animate-pulse"></div>
              ) : (
                <p className="text-lg font-medium ">{autoCollectDetails?.out_standing_amount}</p>
              )}
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-500">Auto-Collect Status</p>
              {isLoading ? (
                <div className="h-5 bg-gray-200 rounded w-40 animate-pulse"></div>
              ) : (
                <p
                  className={`text-lg font-medium ${
                    autoCollectDetails?.status &&
                    colorMapForAutoCollectStatus[autoCollectDetails?.status]
                  }`}
                >
                  {capitalizeAfterSpace(autoCollectDetails?.status)}
                </p>
              )}
            </div>

            {autoCollectDetails?.status === PaymentsInvoiceAutoCollectionStatus.Pending ||
            isLoading ? (
              <button
                className={`w-full text-white font-semibold py-2 px-4 rounded-md transition duration-200 ${
                  isLoading
                    ? "cursor-progress animate-pulse bg-gray-400"
                    : "bg-red-600 hover:bg-red-700"
                }`}
                disabled={isLoading}
                onClick={handleOnCancelClick}
              >
                Cancel Auto-Collect
              </button>
            ) : (
              <p className="text-center text-gray-500">
                At the moment, we cannot cancel auto-collect.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default InvoiceAutoCollectDetailsPage;
